/** 상대 경로와 query를 동일한 URL 구조로 정규화한다. */
const toUrl = (value) => new URL(value || "/", "https://rich.local");

/** leaf 메뉴는 pathname과 메뉴에 선언된 query 값이 모두 같을 때만 활성화한다. */
export const isNavPathExact = (currentPath, itemPath) => {
  if (!currentPath || !itemPath) return false;
  const current = toUrl(currentPath);
  const item = toUrl(itemPath);
  if (current.pathname !== item.pathname) return false;
  for (const [key, value] of item.searchParams.entries()) {
    if (current.searchParams.get(key) !== value) return false;
  }
  return item.search ? current.search === item.search : true;
};

/** branch 메뉴는 query와 무관하게 현재 pathname이 하위 경로인지 확인한다. */
export const isNavPathPartial = (currentPath, itemPath) => {
  if (!currentPath || !itemPath) return false;
  return toUrl(currentPath).pathname.includes(toUrl(itemPath).pathname);
};
